import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const patientInsuranceSelector = (state: RootState) => state.booking.patientInsurance;

export const patientInsuranceFetchingSelector = createSelector(
  patientInsuranceSelector,
  patientInsurance => patientInsurance.isFetching
);

export const patientInsuranceErrorSelector = createSelector(
  patientInsuranceSelector,
  patientInsurance => patientInsurance.error
);

export const patientInsuranceValidSelector = createSelector(
  patientInsuranceSelector,
  patientInsurance => patientInsurance.valid
);
